import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { decorationMobx, storeMobx, advertMobx } from '@mobxStore'
import { IonPage, IonModal, IonContent } from '@ionic/react'
import { modalLayer } from '@utils'
import { Advert } from '@cps'
import { Default, Diy } from './components'
import './index.scss'
import { boJudge } from '@dt/fe-utils'

interface IProps {
}

/** 首页 */
const Home: React.FC = (props: IProps) => {
  const { homeDecorates } = decorationMobx
  useEffect(() => {
    setTimeout(() => {
      if (advertMobx.availableAdsGetStoreMap?.popUps?.home?.length) {
        modalLayer(Advert, {
          type: 'popUps',
          showPage: 'home'
        }, 'popUpsModal', true).then((res) => {
          console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      }
    }, 2000)
  }, [])

  return (
    <IonPage className='home-page'>
      {homeDecorates?.displayMode === 'diy' ? <Diy /> : <Default />}
    </IonPage>
  )
}

export default observer(Home)
